module.exports = __webpack_public_path__ + "img/兔子收纳盒-2.9178f434.jpg";